<div class="grid grid-cols-2 gap-3">
  <app-details-view label="Nazwa">
    {{ name() }}
  </app-details-view>

  <app-details-view label="Ilość">
    <app-number [value]="quantity()" />
  </app-details-view>

  <app-details-view label="Data utworzenia">
    <app-date [date]="createdAt()" />
  </app-details-view>
</div>
